import { type MetaModel } from '@bizzdesign/sdk-knowledgegraph';

export const objectSearchConfig: { [key: string]: MetaModel[] } = {
  ArchiMate: ['ArchiMate'],
  BDCore: ['BDCore'],
  FreeFormat: ['ArchiMate', 'BDCore'],
};
